<template>
    <div :class="wrapClasses">
        <slot></slot>
    </div>
</template>
<script>
    import Icon from '../icon';
    import {oneOf} from '../../utils/assist';

    const prefixCls = 'ivu-list__item';

    export default {
        name: 'ListItem',
        components: {Icon},
        props: {
            size: {
                type: String,
                default: ''
            }
        },
        computed: {
            wrapClasses () {
                return [
                    `${prefixCls}`,
                    {
                        [`${prefixCls}--${this.size}`]: this.size
                    }
                ];
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/list/item.vue